import { type EditorView } from 'prosemirror-view'
import { reviewKey, ReviewPluginState } from './Review'
import { EditorState } from 'prosemirror-state'
import { type Review } from 'stores/Review'

type PluginView = {
  update?: ((view: EditorView, prevState: EditorState) => void) | null
  destroy?: (() => void) | null
}

export class ReviewView implements PluginView {
  store: Review

  constructor(view: EditorView) {
    const { store } = reviewKey.getState(view.state) as ReviewPluginState
    this.store = store
  }

  destroy() {
    this.store.clear()
  }
}
